import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { Button, Switch } from '@companycam/slab-web';
import { translate } from 'translations/i18n';

const ConfigurationModal = ({ isSingleVideo, onSubmit }) => {
  const initialValues = {
    include_details: false,
  };
  return (
    <Formik onSubmit={onSubmit} initialValues={initialValues}>
      {({ values, errors, handleSubmit, isSubmitting, setFieldValue }) => {
        const handleClick = (event) => {
          event.preventDefault();
          setFieldValue('include_details', !values.include_details);
        };
        return (
          <form onSubmit={handleSubmit}>
            {errors.base ? (
              <div className="error-message">{errors.base}</div>
            ) : null}
            <div className="photo-options-on-off">
              <ul className="tg-list">
                <Switch
                  id="include_details"
                  label={translate('galleries.configuration.instructions')}
                  pressed={values.include_details}
                  onClick={handleClick}
                />
              </ul>
            </div>
            <div className="btn-container full">
              <Button
                color="primary"
                type="submit"
                disabled={isSubmitting}
                data-testid="share-modal__button-submit"
              >
                {isSingleVideo
                  ? translate('galleries.configuration.video.submit')
                  : translate('galleries.configuration.submit')}
              </Button>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};

ConfigurationModal.propTypes = {
  isSingleVideo: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

export default ConfigurationModal;
